import { render, staticRenderFns } from "./we-footer.vue?vue&type=template&id=54e6bfb3&"
import script from "./we-footer.vue?vue&type=script&lang=js&"
export * from "./we-footer.vue?vue&type=script&lang=js&"
import style0 from "./we-footer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports